<div
  class="circle"
  [class.xs]="size() === 'xs'"
  [class.lg]="size() === 'lg'"></div>
